import React, { useState, useCallback } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { SmilePlus } from 'lucide-react';
import EmojiPicker, { EmojiClickData, Theme } from 'emoji-picker-react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

interface EmojiPickerPopoverProps {
  onEmojiSelect: (emojiData: EmojiClickData) => void;
}

const EmojiPickerPopover: React.FC<EmojiPickerPopoverProps> = ({ onEmojiSelect }) => {
  const { theme } = useTheme();
  const [open, setOpen] = useState(false); // Add state for popover

  const handleEmojiClick = useCallback((emojiData: EmojiClickData) => {
    console.log('Selected emoji data:', emojiData);
    onEmojiSelect(emojiData); // Pass full emojiData
    setOpen(false); // Close popover after selection
  }, [onEmojiSelect]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="flex-shrink-0">
          <SmilePlus className="h-5 w-5" />
          <span className="sr-only">Add Emoji</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 border-none">
        <EmojiPicker
          onEmojiClick={handleEmojiClick}
          theme={theme === 'dark' ? Theme.DARK : Theme.LIGHT}
          lazyLoadEmojis
        />
      </PopoverContent>
    </Popover>
  );
};

export default EmojiPickerPopover;